// The firms whose weekly court diary comes in the VALS format, and so use the VALS Diary
// page (src/pages/VALSDiary.jsx). Each firm's weeks are saved under that firm, and the
// browser keeps each firm's week apart, so the two diaries never mix.
//
// EAS was added on 20 Oct 2026: Emma confirmed its weekly diary PDF is the same format.

const VALS_STAFF_EMAILS = {
  LF: "l.foley@vals.org.au",
  DE: "d.evans@vals.org.au",
  JO: "j.oneill@vals.org.au",
  GJ: "g.jones@vals.org.au",
  TWB: "t.woodward-brown@vals.org.au",
  MM: "m.morrison@vals.org.au",
  XF: "x.fitzgerald@vals.org.au",
  ET: "e.taylor@vals.org.au",
  GW: "g.williams@vals.org.au",
  SHO: "s.howell@vals.org.au",
  PC: "p.carter@vals.org.au",
  CMR: "c.robinson@vals.org.au",
  JM: "j.miller@vals.org.au",
  DP: "d.patterson@vals.org.au",
  SP: "s.patterson@vals.org.au",
  CM: "c.murphy@vals.org.au",
  HB: "h.bennett@vals.org.au",
};

export const DIARY_FIRMS = {
  vals: {
    brand: "vals",
    name: "VALS",
    entriesKey: "vals_diary_entries",
    sourceFileKey: "vals_diary_source_file",
    staffEmails: VALS_STAFF_EMAILS,
    fallbackEmail: "info@vals.org.au",
    // VALS has the grant reminders guide and diary codes sheet in its portal.
    hasGuides: true,
  },
  eas: {
    brand: "eas",
    name: "EAS",
    entriesKey: "eas_diary_entries",
    sourceFileKey: "eas_diary_source_file",
    // From Emma, 20 Oct 2026. Initials as they appear in EAS's diary. Anyone else's
    // email opens with no address.
    staffEmails: {
      AT: "abdul@easlegal.com.au",
      JP: "joseph@easlegal.com.au",
      JW: "jessica@easlegal.com.au",
    },
    fallbackEmail: "",
    hasGuides: false,
  },
};

export function diaryFirm(firm = "vals") {
  return DIARY_FIRMS[String(firm || "").toLowerCase()] || DIARY_FIRMS.vals;
}
